import React from 'react';
import numeral from 'numeral';
import PropTypes from 'prop-types';

const usd = (num) => numeral(num / 100).format('$0,0.00');
const percent = (num) => numeral(num).format('0,0.00%');
const int = (num) => numeral(num).format('0,0');
const fmtMonth = (num) => {
  const y = Math.floor(num / 12);
  const m = num - (y * 12);
  let str = '';
  if (y) str += ` ${y}yr`;
  if (m) str += ` ${m}mo`;
  return str;
  // return `Y${y} M${m}`;
};

class Amortization extends React.PureComponent {

  constructor(props) {
    super(props);

    // this.state = {
    //   loanAmount: 431_500_00,
    //   apr: 0.0675,
    //   years: 30,
    // };
  }

  get mpr() {
    return this.props.apr / 12;
  }

  get months() {
    return this.props.years * 12;
  }

  get paymentAmount() {
    const {loanAmount} = this.props;
    const {mpr, months} = this;

    if (mpr === 0) return Math.round(loanAmount / this.months);

    const apr = (1 + mpr) ** months;
    const numer = apr * mpr;
    const denom = apr - 1;
    return Math.round(loanAmount * (numer / denom));
  }

  get payments() {
    const payments = [];
    let balance = this.props.loanAmount;
    let cumPaid = 0;
    let cumInterest = 0;
    let cumPrincipal = 0;
    let yCumPaid = 0;
    let yCumInterest = 0;
    let yCumPrincipal = 0;
    let number = 0;
    while (balance > 0) {
      number += 1;
      const isFinal = number === this.months;
      const startingBalance = balance;
      const interest = Math.round(startingBalance * this.mpr);
      const amount = (isFinal ? (interest + startingBalance) : this.paymentAmount); // Math.min(this.paymentAmount, interest + startingBalance);
      const principal = amount - interest;
      balance -= principal;
      const endingBalance = balance;
      cumInterest += interest;
      cumPrincipal += principal;
      cumPaid += amount;
      yCumInterest += interest;
      yCumPrincipal += principal;
      yCumPaid += amount;
      const payment = {number, startingBalance, amount, cumPaid, interest, cumInterest, principal, cumPrincipal, endingBalance, yCumInterest, yCumPrincipal, yCumPaid};
      payments.push(payment);
      const isYear = number % 12 === 0;
      if (isYear) {
        yCumPaid = 0;
        yCumInterest = 0;
        yCumPrincipal = 0;
      }
    }
    return {payments, totalInterest: cumInterest, totalCost: cumPaid};
  }

  render() {
    const {payments, totalInterest, totalCost} = this.payments;
    const {showMonths} = this.props;

    return (
      <div className="amort">
        <ul>
          <li>Loan Amount: {usd(this.props.loanAmount)}</li>
          <li>APR: {percent(this.props.apr)}</li>
          <li>Term: {int(this.props.years)}yr</li>
        </ul>
        <hr />
        <ul>
          <li>Payment: {usd(this.paymentAmount)}</li>
          <li>Total Interest: {usd(totalInterest)}</li>
          <li>Total Cost: {usd(totalCost)}</li>
        </ul>
        <table className="amort-table">
          <thead>
            <tr>
              <th className="left">#</th>
              {/* <th>Starting Balance</th> */}
              <th>Payment</th>
              {/* <th>Cumulative Paid</th> */}
              <th>Interest</th>
              {/* <th>Cumulative Interest</th> */}
              <th>Principal</th>
              <th>Equity Owned</th>
              <th>Remaining Owed</th>
            </tr>
          </thead>
          <tbody>
            {payments.map((payment) => {
              const isYear = payment.number % 12 === 0;
              if (!isYear && !showMonths) return null;
              return (
                <tr key={payment.number}>
                  <td className="left">{fmtMonth(payment.number)}</td>
                  {/* <td>{usd(payment.startingBalance)}</td> */}
                  <td>{showMonths ? usd(payment.amount) : usd(payment.yCumPaid)}</td>
                  {/* <td>{usd(payment.cumPaid)}</td> */}
                  <td>{showMonths ? usd(payment.interest) : usd(payment.yCumInterest)}</td>
                  {/* <td>{usd(payment.cumInterest)}</td> */}
                  <td>{showMonths ? usd(payment.principal) : usd(payment.yCumPrincipal)}</td>
                  <td>{usd(payment.cumPrincipal)}</td>
                  <td>{usd(payment.endingBalance)}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    );
  }

}

Amortization.propTypes = {
  loanAmount: PropTypes.number,
  apr: PropTypes.number,
  years: PropTypes.number,

  showMonths: PropTypes.bool,
};

Amortization.defaultProps = {
  loanAmount: 500_000_00,
  apr: 0.05,
  years: 30,

  showMonths: false,
};

export default Amortization;
